const equipmentList = {
  "belongs-to": "Zugehörig",
  "v-card-title": "Ausrüstungsliste",
  "label-search": "Suche",
  "span-equipment-profile": "Asset-Profil",
  "span-statitics": "Graphik",
  "span-inspections-list": "Inspektionen von diesem Gerät prüfen",
  "span-new-inspections": "Neue Inspektionen",
  "span-repair-list": "Überprüfen Sie die Reparaturprotokolle dieses Geräts",
  "span-new-repair-logs": "Neues Reparaturprotokoll",
  equipImg: "Gerätebild",
  equipTag: "Ausrüstungs-Tag",
  status: "Status Reliability",
  equipType: "Ausstattungsart",
  customer: "Firma",
  area: "Bereich",
  plant: "Zone",
  unit: "Einheit",
  profile: "Profil",
  statitics: "Graphik",
  inspections: "Betriebsinspektionen",
  reliability: "Betriebssicherheitinsprüfungdatum",
  "repair-logs": "Protokolle reparieren"
};

export default equipmentList;
